import script from "./HelpItemQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpItemQuestion.vue?vue&type=script&setup=true&lang=js"

import "./HelpItemQuestion.vue?vue&type=style&index=0&id=76ec91d4&scoped=true&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ec91d4"]])

export default __exports__